<template>
  <v-list-item-avatar :color="color()" :size="size">
    <span class="white--text headline">{{ gethead() }}</span>
  </v-list-item-avatar>
</template>

<script>
import getRendColor from "@/tools/rendomColor";
export default {
  props: {
    size: {
      type: Number,
      default() {
        return 52;
      }
    },
    name: {
      type: String,
      default() {
        return "name";
      }
    }
  },
  methods: {
    gethead() {
      return this.name.substr(0, 2);
    },
    color() {
      let colorList = [
        "blue",
        "yellow",
        "pink",
        "green",
        "indigo",
        "red",
        "purple",
        "primary"
      ];
      let n = this.name.charCodeAt(0) + this.name.charCodeAt(1);
      return getRendColor(colorList, n);
    }
  }
};
</script>

<style></style>
